export const SESSION_ERROR_PAGE =
  'Customer-Session.Web-App.Error-Page.Message.presented';
